<ion-modal [isOpen]="feedbackService?.showFeedbackModal.value">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Feedback</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="form">
        <textarea [(ngModel)]="feedback" class="input" rows="5"></textarea>

        <div class="button-group">
          <button (click)="sendFeedback()" [disabled]="feedback.length < 10 || loading" class="button">
            Versturen
          </button>
          <button (click)="feedbackService.showFeedbackModal.next(false)" class="button button-secondary">
            Annuleren
          </button>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
